import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {DocumentDto} from 'src/app/auto-generated-server-dtos/adjuster/claim/files/document-dto';
import {environment} from "../../../../../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class ListDocumentsService {

    constructor(private httpClient: HttpClient) {
    }

    listDocuments(claimId: number): Observable<DocumentDto[]> {
        return this.httpClient.get<DocumentDto[]>(`${environment.apiServer}/Adjuster/Claim/ListDocuments`, {params: {claimId}});
    }
}
